const keywords = [
    "Real estate",
    "Property",
    "Sahel",
    "Sokhna",
    "New cairo",
    "Elsheikh Zayed",
    "Tagamo3",
    "New capital",
    "3asema",
    "Alamin",
    "Sidi Abdelrahman",
    "Sidi henish",
    "Broker",
    "6th of October",
    "New launch",
    "Gouna",
    "Ras el hekma",
    "Villa",
    "Town house",
    "Twin house",
    "Apartment",
    "Primary",
    "New Zayed",
    "New October",
    "Lowest apartment price",
    "Best price",
    "Connect Homes",
    "كونيكت هومز",
    "كونيكت",
    "Connect",
    "Homes",
    "Franchise",
    "Freelancer",
    "فرانشيس",
    "فريلانسر",
    "Sales",
    "Offer",
    "هومز",
    "الاسكان",
    "عقارات",
    "شقة",
    "بيت",
    "بنت هوس",
    "تون هوس",
    "فيلا",
    "ارخص عقار",
    "افضل بيت",
    "احسن سعر",
    "افضل عقار",
    "Modon",
    "New projects",
    "Egypt real estate"
]



export default keywords;
